import { Component, OnInit } from '@angular/core';
import { AgentService } from '../shared/api/resources/agent/agent.service';
import * as moment from 'moment';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { BookingDetailsComponent } from '../shared/atoms/booking-details/booking-details.component';
import {Booking} from '../shared/api/model/booking';
import {PageInfo} from '../shared/api/model/page-info';
import {AgentReservationService} from '../shared/api/resources/agent-reservation/agent-reservation.service';
import {StaticUtils} from '../shared/utils/static-utils';

@Component({
  selector: 'app-bookings',
  templateUrl: './bookings.component.html',
  styleUrls: ['./bookings.component.scss'],
  providers: []
})


export class BookingsComponent implements OnInit {
  private _searchFilter: string;
  private _sellerFilter: number;
  private _statusFilter: string;
  private _dateFilter: any;
  utils = StaticUtils;
  downloadingReport = false;
  bookings: Booking[];
  moment = moment;
  bookingsLoaded = false;
  pageInfo = new PageInfo();
  allSellers: any[] = [{ label: 'All', value: null }];
  sellers: any[] = [{ label: 'All', value: null }];
  
  statuses = [
    {
      label: 'All',
      value: null
    },
    {
      label: 'Booked',
      value: 'Booked'
    },
    {
      label: 'Canceled',
      value: 'Canceled'
    },
    {
      label: 'Rebooked',
      value: 'Rebooked'
    },
    {
      label: 'Pending',
      value: 'Pending'
    }
  ];
  searchTimeout = setTimeout(() => {}, 0);

  constructor(private _agent: AgentService, private _agentReservations: AgentReservationService, private modalService: NgbModal) { }

  ngOnInit() {
    this.pageInfo.pageSize = 10;
    this.allSellers = [{label: 'All', value: null}];
    this._agent.getSuppliers().subscribe(
      (partners) => {
        for (const partner of  partners) {
          this.allSellers.push({label: partner.brand, value: partner.id});
        }
        this.sellers = [...this.allSellers];
      }
    );
    this.updateBookings();
  }

  openBookingModal(booking: any) {
    const modalRef = this.modalService.open(BookingDetailsComponent, {size: 'lg'});
    modalRef.componentInstance.bookingId = booking.id;
    modalRef.componentInstance.supplierId = booking.event.supplierId;
  }

  updateBookings() {
    this.bookingsLoaded = false;
    this._agentReservations.getBookings(
      this.pageInfo.pageSize,
      this.pageInfo.pageNumber,
      this._sellerFilter,
      this._statusFilter,
      this._dateFilter ? this._dateFilter.start.format('YYYY-MM-DD') + ' 00:00:00' : null,
      this._dateFilter ? this._dateFilter.end.format('YYYY-MM-DD') + ' 23:59:59' : null,
      this._searchFilter
    ).subscribe((bookings) => {
      this.bookings = bookings.result;
      this.pageInfo = bookings.pageInfo;
      this.bookingsLoaded = true;
    });
  }

  downloadBookings() {
    this.downloadingReport = true;
    this._agentReservations.downloadBookings(
      undefined,
      undefined,
      this._sellerFilter,
      this._statusFilter,
      undefined,
      undefined,
      undefined,
      this._dateFilter ? this._dateFilter.start.format('YYYY-MM-DD') + ' 00:00:00' : null,
      this._dateFilter ? this._dateFilter.end.format('YYYY-MM-DD') + ' 23:59:59' : null,
      this._searchFilter
    ).subscribe(
      (response) => {
        const filename = this.getFileNameFromResponseContentDisposition(response);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = filename;
        link.click();
        this.downloadingReport = false;
      },
      () => {
        this.downloadingReport = false;
      }
    );
  }

  getFileNameFromResponseContentDisposition(res: Response) {
    let fileName = moment().format('YYYY-MM-DD') + '_ReportSales.xlsx';
    const contentDisposition = res.headers.get('content-disposition') || '';
    const matches = /filename=([^;]+)/ig.exec(contentDisposition);
    if (matches) {
      fileName = (matches[1]).trim();
    }
    return fileName;
  }

  ticketNumber(id: any) {
    return '#' + id;
  }

  pageChange(pageInfo: PageInfo) {
    this.pageInfo = pageInfo;
    this.updateBookings();
  }

  get sellerFilter(): number {
    return this._sellerFilter;
  }

  set sellerFilter(value: number) {
    if (this._sellerFilter !== value) {
      this._sellerFilter = value;
      this.updateBookings();
    }
  }

  get statusFilter(): string {
    return this._statusFilter;
  }

  set statusFilter(value: string) {
    if (this._statusFilter !== value) {
      this._statusFilter = value;
      this.updateBookings();
    }
  }

  get dateFilter(): any {
    return this._dateFilter;
  }

  set dateFilter(value: any) {
    if (this._dateFilter !== value) {
      this._dateFilter = value;
      this.updateBookings();
    }
  }

  get searchFilter(): string {
    return this._searchFilter;
  }

  set searchFilter(value: string) {
    if (this._searchFilter !== value) {
      this._searchFilter = value;
      clearTimeout(this.searchTimeout);
      if (this._searchFilter.length >= 3 || this._searchFilter === '') {
        this.searchTimeout = setTimeout(() => {
          this.updateBookings();
        }, 1000);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/bookings/bookings.component.ts